module.exports = __webpack_public_path__ + "img/language.59520642.svg";